var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.hideFooter
    ? _c("footer", [
        _c("div", { staticClass: "container" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-md-6 col-lg-3" }, [
              _vm.lodash.get(
                _vm.regionData,
                "footerLinks.popularSearches1.length",
                0
              )
                ? _c("div", { staticClass: "accordion accordion--footer" }, [
                    _c(
                      "div",
                      {
                        staticClass: "footer-section-heading collapsed",
                        attrs: {
                          "aria-controls": "footer-popular-searches1",
                          "data-target": "#footer-popular-searches1",
                          "data-toggle": "collapse"
                        }
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.translate.home.popularSearches) +
                            "\n                    "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "accordion-content collapse",
                        attrs: { id: "footer-popular-searches1" }
                      },
                      [
                        _c(
                          "ul",
                          { staticClass: "footer-list" },
                          _vm._l(
                            _vm.lodash.get(
                              _vm.regionData,
                              "footerLinks.popularSearches1",
                              []
                            ),
                            function(link) {
                              return _c("li", [
                                _c("a", { attrs: { href: link.path } }, [
                                  _vm._v(_vm._s(link.title))
                                ])
                              ])
                            }
                          ),
                          0
                        )
                      ]
                    )
                  ])
                : _vm._e()
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-6 col-lg-3" }, [
              _vm.lodash.get(
                _vm.regionData,
                "footerLinks.popularSearches2.length",
                0
              )
                ? _c("div", { staticClass: "accordion accordion--footer" }, [
                    _c(
                      "div",
                      {
                        staticClass: "footer-section-heading collapsed",
                        attrs: {
                          "aria-controls": "footer-popular-searches2",
                          "data-target": "#footer-popular-searches2",
                          "data-toggle": "collapse"
                        }
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.translate.home.morePopularSearches) +
                            "\n                    "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "accordion-content collapse",
                        attrs: { id: "footer-popular-searches2" }
                      },
                      [
                        _c(
                          "ul",
                          { staticClass: "footer-list" },
                          _vm._l(
                            _vm.lodash.get(
                              _vm.regionData,
                              "footerLinks.popularSearches2",
                              []
                            ),
                            function(link) {
                              return _c("li", [
                                _c("a", { attrs: { href: link.path } }, [
                                  _vm._v(_vm._s(link.title))
                                ])
                              ])
                            }
                          ),
                          0
                        )
                      ]
                    )
                  ])
                : _vm._e()
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-6 col-lg-3" }, [
              _c("div", { staticClass: "accordion accordion--footer" }, [
                _c(
                  "div",
                  {
                    staticClass: "footer-section-heading collapsed",
                    attrs: {
                      "aria-controls": "footer-legals",
                      "data-target": "#footer-legals",
                      "data-toggle": "collapse"
                    }
                  },
                  [
                    _vm._v(
                      _vm._s(_vm.translate.home.legals) +
                        "\n                    "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "accordion-content collapse",
                    attrs: { id: "footer-legals" }
                  },
                  [
                    _c("ul", { staticClass: "footer-list mb-sm-5" }, [
                      _c("li", [
                        _c("a", { attrs: { href: _vm.ourMissionUrl } }, [
                          _vm._v(
                            "\n                                    " +
                              _vm._s(_vm.translate.home.ourMission) +
                              "\n                                "
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _c("a", { attrs: { href: _vm.termsUrl } }, [
                          _vm._v(
                            "\n                                    " +
                              _vm._s(_vm.translate.home.termsAndConditions) +
                              "\n                                "
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _c("a", { attrs: { href: "/datenschutzerklarung/" } }, [
                          _vm._v(
                            "\n                                    " +
                              _vm._s(_vm.translate.home.privacyPolicy) +
                              "\n                                "
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _c("a", { attrs: { href: "/cookie-richtlinie/" } }, [
                          _vm._v(
                            "\n                                    " +
                              _vm._s(_vm.translate.home.cookiePolicy) +
                              "\n                                "
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _c("a", { attrs: { href: "/impressum/" } }, [
                          _vm._v(
                            "\n                                    " +
                              _vm._s(_vm.translate.home.imprint) +
                              "\n                                "
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          attrs: {
                            href: "http://www.age-label.com/parents",
                            target: "_blank"
                          }
                        },
                        [
                          _c(
                            "picture",
                            {
                              attrs: {
                                "data-iesrc":
                                  _vm.cdnUrl + "images/jusprog-age-xml-18.png"
                              }
                            },
                            [
                              _c("source", {
                                attrs: {
                                  srcset:
                                    _vm.cdnUrl +
                                    "images/jusprog-age-xml-18.webp",
                                  type: "image/webp"
                                }
                              }),
                              _vm._v(" "),
                              _c("source", {
                                attrs: {
                                  srcset:
                                    _vm.cdnUrl +
                                    "images/jusprog-age-xml-18.png",
                                  type: "image/png"
                                }
                              }),
                              _vm._v(" "),
                              _c("img", {
                                staticClass: "mt-2",
                                attrs: { alt: "", width: "156", height: "31" }
                              })
                            ]
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "footer-images mb-4 mb-sm-2" }, [
                      _c(
                        "picture",
                        {
                          attrs: {
                            "data-iesrc":
                              _vm.cdnUrl +
                              "images/footersssl_small_compressed.png"
                          }
                        },
                        [
                          _c("source", {
                            attrs: {
                              srcset:
                                _vm.cdnUrl +
                                "images/footersssl_small_compressed.webp",
                              type: "image/webp"
                            }
                          }),
                          _vm._v(" "),
                          _c("source", {
                            attrs: {
                              srcset:
                                _vm.cdnUrl +
                                "images/footersssl_small_compressed.png",
                              type: "image/png"
                            }
                          }),
                          _vm._v(" "),
                          _c("img", {
                            staticClass: "footersssl",
                            attrs: { alt: "", width: "342", height: "91" }
                          })
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticClass:
                            "footer-twitter-image ml-sm-3 mt-3 mt-sm-0",
                          attrs: {
                            href: "https://twitter.com/Erobella_de",
                            target: "_blank"
                          }
                        },
                        [
                          _c(
                            "picture",
                            {
                              attrs: {
                                "data-iesrc":
                                  _vm.cdnUrl + "images/footer-twitter.png"
                              }
                            },
                            [
                              _c("source", {
                                attrs: {
                                  srcset:
                                    _vm.cdnUrl +
                                    "images/footer-twitter-new.webp",
                                  type: "image/webp"
                                }
                              }),
                              _vm._v(" "),
                              _c("source", {
                                attrs: {
                                  srcset:
                                    _vm.cdnUrl + "images/footer-twitter.png",
                                  type: "image/png"
                                }
                              }),
                              _vm._v(" "),
                              _c("img", {
                                attrs: { alt: "", width: "130", height: "24" }
                              })
                            ]
                          )
                        ]
                      )
                    ])
                  ]
                )
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "col-12 d-flex flex-column justify-content-center align-items-start my-4 d-sm-none"
              },
              [_c("region-selector-component", { staticClass: "w-50" })],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-12 col-sm-6 col-lg-3 mt-0 footer-details" },
              [
                _c(
                  "picture",
                  {
                    attrs: {
                      "data-iesrc":
                        _vm.cdnUrl + "images/footer-image-17-05-2023.png"
                    }
                  },
                  [
                    _c("source", {
                      attrs: {
                        srcset:
                          _vm.cdnUrl + "images/footer-image-17-05-2023.webp",
                        type: "image/webp"
                      }
                    }),
                    _vm._v(" "),
                    _c("source", {
                      attrs: {
                        srcset:
                          _vm.cdnUrl + "images/footer-image-17-05-2023.png",
                        type: "image/png"
                      }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      staticClass: "footer-image",
                      attrs: { alt: "", width: "260", height: "229" }
                    })
                  ]
                ),
                _vm._v(" "),
                _c("region-selector-component", {
                  staticClass: "d-none d-sm-flex"
                })
              ],
              1
            )
          ])
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-69bf8516", { render: render, staticRenderFns: staticRenderFns })
  }
}